import styled from 'styled-components'

const SearchBoxContainer = styled.div`
    width: 100%;
    text-align: right;
`

export { SearchBoxContainer }
